import React, { useState } from 'react';
import {
    Box,
    Typography,
    Card,
    CardContent,
    CardActions,
    Button,
    Grid,
    Alert,
    FormControlLabel,
    Switch
} from '@mui/material';
import {
    Refresh,
    Send,
    Email,
    ForwardToInbox,
    Info
} from '@mui/icons-material';

export default function ManualProcessingTab({ onBulkAction, isProcessing }) {
    const [dryRunEnabled, setDryRunEnabled] = useState(true);

    return (
        <Box sx={{ maxWidth: '800px', mx: 'auto' }}>
            <Card sx={{ mb: 2 }}>
                <CardContent>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                        <Typography variant="h6">Processing Controls</Typography>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={dryRunEnabled}
                                    onChange={(e) => setDryRunEnabled(e.target.checked)}
                                />
                            }
                            label="Dry Run Mode"
                        />
                    </Box>

                    {dryRunEnabled && (
                        <Alert severity="info" sx={{ mb: 2 }}>
                            Dry run mode is enabled. No emails will actually be sent.
                        </Alert>
                    )}

                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <Card variant="outlined">
                                <CardContent>
                                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                        <Refresh sx={{ mr: 1 }} />
                                        <Typography variant="h6">Check Emails</Typography>
                                    </Box>
                                    <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                                        Scan for new emails without sending replies. Safe for testing.
                                    </Typography>
                                </CardContent>
                                <CardActions>
                                    <Button
                                        fullWidth
                                        variant="contained"
                                        onClick={() => onBulkAction('check', dryRunEnabled)}
                                        disabled={isProcessing}
                                    >
                                        Check All Partners
                                    </Button>
                                </CardActions>
                            </Card>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <Card variant="outlined">
                                <CardContent>
                                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                        <Send sx={{ mr: 1 }} />
                                        <Typography variant="h6">Process Emails</Typography>
                                    </Box>
                                    <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                                        Scan and send automatic replies to new emails.
                                    </Typography>
                                </CardContent>
                                <CardActions>
                                    <Button
                                        fullWidth
                                        variant="contained"
                                        color="primary"
                                        onClick={() => onBulkAction('process', dryRunEnabled)}
                                        disabled={isProcessing}
                                    >
                                        Process All Partners
                                    </Button>
                                </CardActions>
                            </Card>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <Card variant="outlined">
                                <CardContent>
                                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                        <Email sx={{ mr: 1 }} />
                                        <Typography variant="h6">Process Follow-ups</Typography>
                                    </Box>
                                    <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                                        Send follow-up emails for existing threads based on timing.
                                    </Typography>
                                </CardContent>
                                <CardActions>
                                    <Button
                                        fullWidth
                                        variant="contained"
                                        color="secondary"
                                        onClick={() => onBulkAction('followup', dryRunEnabled)}
                                        disabled={isProcessing}
                                    >
                                        Process Follow-ups
                                    </Button>
                                </CardActions>
                            </Card>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <Card variant="outlined">
                                <CardContent>
                                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                        <ForwardToInbox sx={{ mr: 1 }} />
                                        <Typography variant="h6">Process Forwarded</Typography>
                                    </Box>
                                    <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                                        Process emails sent to partnerships@ forwarding aliases.
                                    </Typography>
                                </CardContent>
                                <CardActions>
                                    <Button
                                        fullWidth
                                        variant="contained"
                                        color="info"
                                        onClick={() => onBulkAction('forwarded', dryRunEnabled)}
                                        disabled={isProcessing}
                                    >
                                        Process Forwarded
                                    </Button>
                                </CardActions>
                            </Card>
                        </Grid>
                    </Grid>

                    <Box sx={{ mt: 3 }}>
                        <Alert severity="warning" icon={<Info />}>
                            <Typography variant="body2">
                                <strong>Important:</strong> These operations run the same logic as the automated cron jobs. 
                                Use dry run mode first to verify behavior before sending real emails.
                            </Typography>
                        </Alert>
                    </Box>
                </CardContent>
            </Card>
        </Box>
    );
}